module.exports = __webpack_public_path__ + "img/38568746041_20e97ef3ec_w.cf04d9d2.jpg";